import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {HttpTrackingRepository} from '../Repositories/HttpTrackingRepository.js'

class GetUserTraitsTrackingUseCase extends UseCase {
  #config
  #repository

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  static create({config}) {
    return new GetUserTraitsTrackingUseCase({config, repository: HttpTrackingRepository.create({config})})
  }

  @tracer({metric: 'GetUserTraitsTrackingUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    try {
      const [error, response] = await this.#repository.getUserTraits({config: this.#config})

      return error
        ? Promise.reject(
            DomainSharedError.isDomainError({error})
              ? error
              : DomainSharedError.createGenericError({config: this.#config, cause: error})
          )
        : response
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({config: this.#config, cause: error}))
    }
  }
}

export const factory = GetUserTraitsTrackingUseCase.create
